/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ResponseDictionaryStringString', 'model/ResponseObject', 'model/ReverseGeocodingConfigurationResource'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ResponseDictionaryStringString'), require('../model/ResponseObject'), require('../model/ReverseGeocodingConfigurationResource'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ReverseGeocodingSettingsApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.ResponseDictionaryStringString, root.GisServerApis.ResponseObject, root.GisServerApis.ReverseGeocodingConfigurationResource);
  }
}(this, function(ApiClient, ResponseDictionaryStringString, ResponseObject, ReverseGeocodingConfigurationResource) {
  'use strict';

  /**
   * ReverseGeocodingSettings service.
   * @module api/ReverseGeocodingSettingsApi
   * @version 1.0.0
   */

  /**
   * Constructs a new ReverseGeocodingSettingsApi. 
   * @alias module:api/ReverseGeocodingSettingsApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the getSettingsV1 operation.
     * @callback module:api/ReverseGeocodingSettingsApi~getSettingsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseDictionaryStringString} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the settings for the reverse geocoding.
     * @param {module:api/ReverseGeocodingSettingsApi~getSettingsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseDictionaryStringString}
     */
    this.getSettingsV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseDictionaryStringString;

      return this.apiClient.callApi(
        '/api/v1/reversegeocoding/settings', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateSettingsV1 operation.
     * @callback module:api/ReverseGeocodingSettingsApi~updateSettingsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the settings for the reverse geocoding.
     * @param {Object} opts Optional parameters
     * @param {module:model/ReverseGeocodingConfigurationResource} opts.item The settings information to set.
     * @param {module:api/ReverseGeocodingSettingsApi~updateSettingsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.updateSettingsV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['item'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/reversegeocoding/settings', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

